import { webapi } from '@/api/webapi.ts';
import { cancelTargetAccumulatorRfs } from '@/store/targetAccumulator/api/multiPass/cancelTargetAccumulatorRfs.ts';
import { executeTargetAccumulatorRfs } from '@/store/targetAccumulator/api/multiPass/executeTargetAccumulatorRfs.ts';
import { requestTargetAccumulatorRfs } from '@/store/targetAccumulator/api/multiPass/requestTargetAccumulatorQuote.ts';
import { checkTargetAccumulator } from '@/store/targetAccumulator/api/tradeCapture/checkTargetAccumulator.ts';

export const targetAccumulatorApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    checkTargetAccumulator: checkTargetAccumulator(builder),
    requestTargetAccumulatorRfs: requestTargetAccumulatorRfs(builder),
    cancelTargetAccumulatorRfs: cancelTargetAccumulatorRfs(builder),
    executeTargetAccumulatorRfs: executeTargetAccumulatorRfs(builder),
  }),
});

export const { useCheckTargetAccumulatorMutation, useCancelTargetAccumulatorRfsMutation } = targetAccumulatorApi;

export const { matchFulfilled: matchCheckTargetAccumulatorFulfilled } =
  targetAccumulatorApi.endpoints.checkTargetAccumulator;
